/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar24 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar24", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.916016 14.306641 C 12.493016 14.306641 13.548828 15.151484 13.548828 16.396484 C 13.548828 17.177484 13.089844 17.871375 11.839844 18.984375 L 10.677734 20.052734 L 10.677734 20.146484 L 13.646484 20.146484 L 13.646484 21.542969 L 8.2890625 21.542969 L 8.2890625 20.347656 L 10.515625 18.251953 C 11.550625 17.294953 11.814453 16.939437 11.814453 16.523438 C 11.814453 16.005437 11.434516 15.658203 10.853516 15.658203 C 10.248516 15.658203 9.828125 16.069391 9.828125 16.650391 L 9.828125 16.683594 L 8.1875 16.683594 L 8.1875 16.654297 C 8.1875 15.253297 9.2810156 14.306641 10.916016 14.306641 z M 18.474609 14.498047 L 20.958984 14.498047 L 20.958984 19.005859 L 21.837891 19.005859 L 21.837891 20.400391 L 20.958984 20.400391 L 20.958984 21.544922 L 19.265625 21.544922 L 19.265625 20.400391 L 15.808594 20.400391 L 15.808594 18.902344 C 16.448594 17.676344 17.258609 16.343047 18.474609 14.498047 z M 19.220703 15.777344 C 18.620703 16.705344 18.146469 17.505469 17.355469 18.980469 L 17.355469 19.068359 L 19.308594 19.068359 L 19.308594 15.777344 L 19.220703 15.777344 z" />
      </svg>
    );
  }
}

IconCalendar24.defaultProps = {
  className: null
};

IconCalendar24.propTypes = {
  className: PropTypes.string
};

export default IconCalendar24;
